export const jobCampaignStrings = {
  pageTitle: "Campañas de reclutamiento",
  newCampaign: "Nueva campaña",
  setupTitle: "Configuración del agente",
  listEmpty: "No hay campañas de reclutamiento.",
  activeBadge: "Activa",
  activate: "Activar",
  editSetup: "Editar campaña",
  fieldName: "Nombre",
  fieldDescription: "Descripción",
  fieldVoicePrompt: "Prompt agente de voz",
  fieldWhatsappPrompt: "Prompt agente WhatsApp",
  fieldWhatsappTemplateName: "Plantilla WhatsApp (apertura)",
  fieldWhatsappTemplateLanguage: "Idioma de la plantilla",
  whatsappTemplateHint:
    "Tras la llamada de voz se envía esta plantilla para abrir la conversación con el candidato. Por defecto se copia de la última campaña.",
  captureFieldsTitle: "Campos a capturar",
  addField: "Agregar campo",
  fieldKey: "Clave",
  fieldLabel: "Etiqueta",
  fieldRequired: "Obligatorio",
  meetHint:
    "Al guardar, el CRM crea el evento de Google Calendar con Meet (cuenta admin@laceiba.group) e invita al Director de Ventas. Cada candidato asignado recibe la invitación por correo y la plantilla por WhatsApp.",
  stepGeneral: "General",
  stepAgents: "Agentes",
  stepScreening: "Filtro",
  stepCaptureFields: "Datos a capturar",
  stepMeet: "Meet grupal",
  stepGeneralHint: "Cómo se identifica la campaña en el CRM.",
  stepAgentsHint: "Qué dicen el agente de voz y el de WhatsApp, y con qué plantilla se abre la conversación.",
  stepScreeningHint: "Cómo se filtra al candidato: perfil ideal, hoja de vida y video.",
  stepCaptureFieldsHint: "Datos que el agente de WhatsApp debe obtener antes de pedir la hoja de vida.",
  stepMeetHint: "Una sola reunión virtual para todos los candidatos seleccionados.",
  stepInvalid: "Revisa este paso",
  removeField: "Quitar campo",
  back: "Atrás",
  next: "Siguiente",
  fieldMeetScheduledAt: "Fecha y hora del Meet",
  meetTimezoneHint: "Hora de Colombia (America/Bogotá).",
  fieldMeetDuration: "Duración (minutos)",
  fieldSalesDirectorEmail: "Correo del Director de Ventas",
  salesDirectorHint: "Recibe la invitación de Google Calendar del Meet.",
  fieldMeetTemplateName: "Plantilla WhatsApp del Meet",
  fieldMeetTemplateLanguage: "Idioma de la plantilla",
  meetTemplateHint:
    "Variables del cuerpo: contact_name, date_ y time. El botón es de URL dinámica https://meet.google.com/{{1}}; el CRM envía el código del Meet.",
  meetLinkLabel: "Enlace del Meet",
  meetLinkPending: "El enlace de Google Meet se genera al guardar la campaña.",
  meetLinkFailed:
    "Hay fecha, pero no se pudo crear el Google Meet. Guarda de nuevo para reintentar.",
  copyLink: "Copiar enlace",
  linkCopied: "Enlace copiado",
  meetPreviewTitle: "Vista previa del mensaje",
  meetPreviewGreeting: "Hola",
  meetPreviewSampleName: "Ariel",
  meetPreviewNoDate: "Elige la fecha para ver la vista previa",
  meetPreviewButton: "Unirse a la reunión",
  meetPreviewLines: [
    "Gracias por completar esta etapa del proceso.",
    "El siguiente paso es una conversación virtual con nuestro Líder de Ventas, donde podrán conocerse y hablar sobre la oportunidad.",
  ],
  meetPreviewClosing: "Te esperamos aquí 👇",
  errorNameRequired: "El nombre es obligatorio.",
  errorCaptureKeys: "Cada campo necesita una clave única.",
  errorMeetDateRequired: "Define la fecha del Meet.",
  errorMeetTemplateRequired: "Indica el nombre de la plantilla del Meet.",
  errorEmailInvalid: "Correo no válido.",
  errorMeetDuration: "Mínimo 15 minutos.",
  campaignMeetLabel: "Meet grupal",
  assignMeetDisabledHint:
    "Configura la fecha y la plantilla del Meet grupal en la campaña (paso Meet grupal) o crea cupos en Entrevistas.",
  assignInterviewError:
    "No se pudo asignar el Meet. Revisa que la campaña tenga la plantilla del Meet configurada.",
  assignInterviewSent: "Invitación enviada por WhatsApp y Google Calendar.",
  save: "Guardar",
  cancel: "Cancelar",
  create: "Crear",
  activateOnCreate: "Activar al crear",
  tabLeads: "Candidatos",
  tabConversation: "Conversación",
  tabInterviews: "Entrevistas",
  candidatesEmpty: "No hay candidatos en esta campaña.",
  addCandidate: "Agregar candidato",
  addCandidateTitle: "Nuevo candidato",
  editCandidate: "Editar",
  editCandidateTitle: "Editar candidato",
  fieldCandidateName: "Nombre",
  fieldCandidatePhone: "Teléfono",
  fieldCandidateEmail: "Correo electrónico",
  promote: "Promover a ventor",
  reject: "Rechazar",
  retryVoice: "Llamar (voz)",
  startWhatsapp: "Iniciar WhatsApp",
  assignInterview: "Asignar siguiente Meet",
  conversationEmpty: "Sin mensajes aún.",
  interviewsEmpty: "No hay entrevistas en cola.",
  nextInterview: "Siguiente",
  newInterview: "Nueva entrevista",
  scheduledAt: "Fecha y hora",
  interviewTitle: "Título",
  meetLink: "Meet",
  cancelInterview: "Cancelar cupo",
  status: "Estado",
  candidates: "Candidatos",
  availableSlots: "Cupos Meet",
  screeningTitle: "Filtro: hoja de vida y video",
  fieldRequirements: "Requisitos del perfil",
  requirementsHint:
    "La IA compara la hoja de vida del candidato con estos requisitos y asigna un puntaje de 0 a 100.",
  fieldCvRequestMessage: "Mensaje para pedir la hoja de vida",
  fieldVideoRequestMessage: "Mensaje para pedir el video (1 minuto)",
  fieldVideoReceivedMessage: "Mensaje al recibir el video",
  sortByScore: "Mejor puntaje primero",
  sortByRecent: "Más recientes",
  scoreLabel: "Puntaje IA",
  scorePending: "Sin puntaje",
  profileTitle: "Perfil del candidato",
  selectCandidateHint:
    "Selecciona un candidato de la lista para ver su hoja de vida, el puntaje de la IA y su video.",
  profileSummary: "Resumen de la IA",
  profileStrengths: "Fortalezas",
  profileGaps: "Brechas",
  profileYearsExperience: "años de experiencia",
  profileAnalyzedAt: "Analizado",
  viewCv: "Ver hoja de vida",
  rescoreCv: "Re-analizar CV",
  videoTitle: "Video de presentación",
  videoPending: "El candidato aún no ha enviado su video.",
  cvEmptyTitle: "Aún no hay hoja de vida",
  cvEmptyBody:
    "Cuando el candidato complete sus datos por WhatsApp se le pedirá la hoja de vida; al recibirla verás aquí el puntaje y el resumen.",
  cvNoTextHint:
    "No se pudo leer el texto del archivo (¿PDF escaneado?). Revisa el CV manualmente.",
  cvAnalysisPending:
    "La hoja de vida se está analizando. Si el puntaje no aparece, usa Re-analizar CV.",
  facebookLeadTitle: "Respuestas del formulario",
  facebookLeadPlatformFacebook: "Facebook",
  facebookLeadPlatformInstagram: "Instagram",
  facebookLeadCampaign: "Campaña",
  removeCandidate: "Eliminar",
  removeCandidateAria: "Eliminar candidato",
  removeCandidateTitle: "¿Eliminar a este candidato?",
  removeCandidateBody: "Se borrará de forma permanente todo lo relacionado con",
  removeCandidateItems: [
    "La conversación de WhatsApp desde que se postuló",
    "La hoja de vida y su análisis de IA",
    "El video de presentación",
    "Los datos capturados y el historial del candidato",
  ],
  removeCandidateKeepsLead:
    "El registro del lead de Facebook se conserva para los reportes de anuncios. Si tenía una entrevista asignada, el espacio queda libre.",
  removeCandidateIrreversible: "Esta acción no se puede deshacer.",
  removeCandidateConfirm: "Eliminar candidato",
  removeCandidateCancel: "Cancelar",
  removeCandidateError: "No se pudo eliminar el candidato. Inténtalo de nuevo.",
  preferredContactLabel: "Prefiere contacto por",
  preferredContactCall: "Llamada (se llamó con el agente de voz)",
  preferredContactWhatsapp: "WhatsApp (se abrió WhatsApp sin llamada)",
  preferredContactEmail: "Correo (se abrió WhatsApp sin llamada)",
  meetBatchSelectAll: "Seleccionar todos",
  meetBatchSelected: "seleccionados",
  meetBatchSend: "Enviar Meet por WhatsApp",
  meetBatchDisabledHint:
    "Configura la fecha del Meet y la plantilla de WhatsApp en «Editar campaña» para enviar el Meet.",
  meetBatchConfirmTitle: "¿Enviar la invitación al Meet?",
  meetBatchConfirmBody:
    "Se enviará la plantilla de WhatsApp del Meet y la invitación de Google Calendar a",
  meetBatchConfirmCandidates: "candidatos",
  meetBatchConfirmPacing:
    "Para evitar que WhatsApp lo marque como spam, se envían 5 mensajes cada 30 segundos. Tiempo estimado:",
  meetBatchConfirmSkipNote:
    "Los candidatos que ya están en cola o enviándose no se vuelven a enviar.",
  meetBatchConfirm: "Enviar",
  meetBatchCancel: "Cancelar",
  meetBatchQueued: "en cola",
  meetBatchSkipped: "omitidos",
  meetBatchError: "No se pudo poner en cola el envío. Inténtalo de nuevo.",
  meetBatchRowAria: "Seleccionar candidato",
  meetStatusLabel: "Meet WhatsApp",
  meetStatusQueued: "En cola",
  meetStatusSending: "Enviando",
  meetStatusSent: "Enviado",
  meetStatusDelivered: "Entregado",
  meetStatusRead: "Leído",
  meetStatusFailed: "Falló",
  meetStatusSpam: "Bloqueado / spam",
  meetStatusSpamHint:
    "WhatsApp no entregó el mensaje por políticas de calidad o porque la persona no acepta mensajes de marketing.",
  meetStatusUpdatedAt: "Actualizado",
  stepFilterLabel: "Filtrar por paso",
  stepFilterAll: "Todos",
  stepFilterEmpty: "Ningún candidato en este paso.",
  stepArrived: "Llegó",
  stepVoiceQueued: "Llamada en cola",
  stepVoiceCompleted: "Llamada completada",
  stepVoiceDeclined: "Rechazó llamada",
  stepWhatsappCapturing: "Capturando datos (WhatsApp)",
  stepDataComplete: "Datos completos",
  stepAwaitingCv: "Esperando CV",
  stepAwaitingVideo: "Esperando video",
  stepVideoReceived: "Video recibido",
  stepInterviewAccepted: "Aceptó entrevista",
  stepInterviewScheduled: "Meet asignado",
  stepSelected: "Seleccionado",
  stepRejected: "Rechazado",
  stepDiscarded: "Descartado",
} as const
